import React from 'react';
import {Link} from 'react-router-dom';
import {BaseComponent as Component} from 'BaseComponent';
import URL from 'url';
import {connect} from 'react-redux';

class NotFoundComponent extends Component {
    render() {
        return (
            <div>
                Page not found. Back to&nbsp;
                <Link to={URL.toHome()}>home</Link>
            </div>
        );
    }
}

export default connect(() => ({}))(NotFoundComponent);
